export default __webpack_public_path__ + "static/DroneCTF-f48e766902bb4e5f24af976e06588662.png";